'use client'

import React from 'react'
import { cn } from '../../../../../lib/utils'
import { ButtonProps } from '../../../Button'

import s from '../../../../styles/animations.module.css'
import { Icon, iconTypes } from '../../../Icon'
import { Chip, ChipProps } from '../../../Chip'

export type WorkflowTileProps = {
  isSelected: boolean
  description: string
  title: string
  id: string
  icon?: iconTypes
  handleClick?: () => void
}

export const WorkflowTile = (props: WorkflowTileProps) => {
  const { isSelected, description, title, id, icon, handleClick } = props

  return (
    <div
      className={cn(
        'rounded-lg flex p-2 flex flex-col hover:bg-muted w-full cursor-pointer',
        {
          'bg-accent': isSelected,
        },
        s.smallTransitionIn,
      )}
      title={`list-tile-${id}`}
      onClick={(e) => {
        // Prevents the click event from firing when clicking on a button
        if ((e.target as HTMLElement).tagName === 'BUTTON') {
          return
        }

        handleClick && handleClick()
      }}
    >
      <div className="flex flex-row gap-1 text-sm items-center underline decoration-dotted">
        <Icon name={icon || 'Zap'}></Icon>
        {title}
      </div>
      <div className="text-xs text-muted-foreground`">{description}</div>
    </div>
  )
}
